/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CheckFilled: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM15.2803 6.32715C14.9874 6.03426 14.5126 6.03426 14.2197 6.32715L7.96387 12.582L5.78027 10.3984C5.4874 10.1056 5.0126 10.1056 4.71973 10.3984C4.427 10.6913 4.42695 11.1661 4.71973 11.459L7.43359 14.1738C7.72631 14.4664 8.20125 14.4661 8.49414 14.1738L15.2803 7.3877C15.5731 7.09485 15.573 6.62005 15.2803 6.32715Z"
      fill={props.style?.color}
    />
  </svg>
);

export default CheckFilled;
